<template>
  <div class="-wallpaper" @click="editAssetFromRoot">
    <div class="-inner" :style="[styleObj]">
      <div v-if="showActions && !overlay" class="-actions">
        <wt-asset-locate @locate="$emit('locate')" :asset="asset" />
        <wt-asset-remove @remove="$emit('remove')" ref="remove" />
        <wt-asset-edit
          v-if="showActions && !overlay"
          ref="edit"
          @edit="editAsset"
        />
        <wt-asset-add :disabled="!canAdd" @add="$emit('add')" ref="add" />
      </div>
    </div>

    <div v-if="!overlay" class="-indicators">
      <transition name="wt2-fade-fast">
        <wt-asset-used v-if="isUsed" />
      </transition>
    </div>

    <div v-if="!overlay" class="-hex-color" :style="hexLabelStyle">
      {{ hex }}
    </div>
    <wt-asset-icons-overlay-asset
      v-if="overlay"
      :duration="displayDuration"
      :icons="iconsForOverlayAsset"
    />
    <wt-asset-icons
      v-else
      :restrictions="assetRestrictions"
      :icons="icons"
      class="-no-gradient"
    />
    <div class="-border-layer" />
  </div>
</template>

<script>
import AssetMixins from 'components/assets/mixins/AssetMixins.vue';
import AssetIconsForOverlayAsset from 'components/assets/mixins/AssetIconsForOverlayAsset.vue';
import AssetIcons from 'components/assets/mixins/AssetIcons.vue';

export default {
  mixins: [AssetMixins],
  components: {
    'wt-asset-icons-overlay-asset': AssetIconsForOverlayAsset,
    'wt-asset-icons': AssetIcons,
  },

  methods: {
    editAsset() {
      this.$emit('edit');
    },

    editAssetFromRoot(e) {
      if (this.overlay) {
        this.$emit('preview-asset');
      } else {
        if (
          this.$refs.remove.$el.contains(e.target) ||
          this.$refs.edit.$el.contains(e.target) ||
          this.$refs.add.$el.contains(e.target)
        ) {
          return;
        }
        this.editAsset();
      }
    },
  },

  computed: {
    hex() {
      if (this.type === 'SOLID') {
        return tinycolor(this.styleObj.background).toHexString().toUpperCase();
      }

      return app.culture.get('wallpaper.gradient');
    },
    type() {
      return this.asset.wallpaperMetaData.type;
    },
    styleObj() {
      return app.computeBgFromColorData(
        this.asset.wallpaperMetaData.wallpaperData
      );
    },
    hexLabelStyle() {
      let labelColor;
      if (this.type === 'SOLID') {
        const cardColor = tinycolor(this.styleObj.background);
        labelColor = cardColor.isLight() ? 'rgba(0,0,0,0.3)' : '#fff';
      } else {
        labelColor = '#fff';
      }

      return {
        color: labelColor,
      };
    },
  },
};
</script>
